import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "has-first-letter-uppercase has-text-success is-size-5" }
const _hoisted_2 = { class: "columns w-100 my-3" }
const _hoisted_3 = { class: "column is-5" }
const _hoisted_4 = { class: "column is-7" }
const _hoisted_5 = { class: "is-flex is-flex-direction-column h-100" }
const _hoisted_6 = { class: "is-italic flex-0" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item_gi = _resolveComponent("n-form-item-gi")!
  const _component_n_input_number = _resolveComponent("n-input-number")!
  const _component_n_date_picker = _resolveComponent("n-date-picker")!
  const _component_n_grid = _resolveComponent("n-grid")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_n_auto_complete = _resolveComponent("n-auto-complete")!
  const _component_avolta_map = _resolveComponent("avolta-map")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    ref: "modal",
    width: "60vw"
  }, {
    header: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.stationToUpdate?.name), 1 /* TEXT */)
    ]),
    body: _withCtx(() => [
      (_ctx.failed)
        ? (_openBlock(), _createBlock(_component_n_alert, {
            key: 0,
            title: _ctx.$t('station_list.edit.failure'),
            type: "error"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('global.try_again')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_n_form, {
            ref: "formInst",
            model: _ctx.result,
            "onUpdate:model": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.result) = $event)),
            rules: _ctx.rules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_grid, {
                "x-gap": 5,
                "y-gap": 5,
                cols: 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_form_item_gi, {
                    span: 2,
                    label: _ctx.$t('station_list.edit.field_address'),
                    path: "address"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input, {
                        value: _ctx.result.address,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.result.address) = $event)),
                        clearable: "",
                        placeholder: ""
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["label"]),
                  _createVNode(_component_n_form_item_gi, {
                    span: 1,
                    label: _ctx.$t('station_list.edit.field_city'),
                    path: "city"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input, {
                        value: _ctx.result.city,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.result.city) = $event)),
                        clearable: "",
                        placeholder: ""
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["label"]),
                  _createVNode(_component_n_form_item_gi, {
                    span: 1,
                    label: _ctx.$t('station_list.edit.field_postcode'),
                    path: "postcode"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input, {
                        value: _ctx.result.postcode,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.result.postcode) = $event)),
                        clearable: "",
                        placeholder: ""
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["label"]),
                  _createVNode(_component_n_form_item_gi, {
                    span: 1,
                    label: _ctx.$t('station_list.edit.field_state'),
                    path: "state"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input, {
                        value: _ctx.result.state,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.result.state) = $event)),
                        clearable: "",
                        placeholder: ""
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["label"]),
                  _createVNode(_component_n_form_item_gi, {
                    span: 1,
                    label: _ctx.$t('station_list.edit.field_country'),
                    path: "country"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input, {
                        value: _ctx.result.country,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.result.country) = $event)),
                        clearable: "",
                        placeholder: ""
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["label"]),
                  _createVNode(_component_n_form_item_gi, {
                    span: 1,
                    label: _ctx.$t('station_list.edit.field_latitude'),
                    path: "lat"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input_number, {
                        value: _ctx.result.latitude,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.result.latitude) = $event)),
                        min: -90,
                        max: 90,
                        "show-button": false,
                        clearable: "",
                        style: {"width":"100%"},
                        placeholder: ""
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["label"]),
                  _createVNode(_component_n_form_item_gi, {
                    span: 1,
                    label: _ctx.$t('station_list.edit.field_longitude'),
                    path: "lon"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_input_number, {
                        value: _ctx.result.longitude,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.result.longitude) = $event)),
                        min: -180,
                        max: 180,
                        "show-button": false,
                        clearable: "",
                        width: "100%",
                        style: {"width":"100%"},
                        placeholder: ""
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["label"]),
                  _createVNode(_component_n_form_item_gi, {
                    span: 1,
                    label: _ctx.$t('station_list.edit.field_installed'),
                    path: "installed"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_date_picker, {
                        value: _ctx.result.installed,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.result.installed) = $event)),
                        type: "datetime",
                        clearable: ""
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["label"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["model", "rules"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_n_auto_complete, {
              class: "flex-0",
              clearable: "",
              loading: _ctx.loading,
              "show-empty": true,
              placeholder: _ctx.$t('station_list.edit.field_address_search'),
              options: _ctx.autoCompleteOptions,
              "on-select": _ctx.onSearchSelect,
              "on-update:value": _ctx.debounceSearch,
              "input-props": {autocomplete: 'disabled', loading: _ctx.loading }
            }, null, 8 /* PROPS */, ["loading", "placeholder", "options", "on-select", "on-update:value", "input-props"]),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('station_list.edit.click_to_set_position')), 1 /* TEXT */),
            _createVNode(_component_avolta_map, {
              ref: "map",
              class: "flex-1",
              "onMap:dblclick": _cache[9] || (_cache[9] = ($event: any) => (_ctx.onMapClick($event))),
              stations: [_ctx.mapStation],
              center: _ctx.center,
              zoom: _ctx.zoom
            }, null, 8 /* PROPS */, ["stations", "center", "zoom"])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "button is-light mr-2",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.close(false)))
      }, _toDisplayString(_ctx.$t('global.cancel')), 1 /* TEXT */),
      _createElementVNode("button", {
        class: "button is-success",
        disabled: !_ctx.valid || _ctx.pristine,
        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, _toDisplayString(_ctx.$t('global.ok')), 9 /* TEXT, PROPS */, _hoisted_7)
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}